var smoothScroll = require('smooth-scroll');
require('swipe-js');

require('./gallery.scss');

var defaults = {
  callback: null,
  transitionEnd: null,
  speed: 1100,
  auto: 4100,
  startSlide: 0,
  continuous: true,
  disableScroll: false,
  stopPropagation: false,

  navigation: false,
  startOnAppear: true,
};

var swipe;

function Gallery(container, opts) {
  opts = $.extend({}, defaults, opts);
  var swipe,
    that = this;

  this.createContainer = function() {
    // slides container
    this.container = $('<div class="gallery-wrap">').append(this.slides);
    $(container).addClass('swipe')
      .append(this.container);
  };

  this.createNavigator = function() {
    this.navigator = $('<div class="gallery-nav">');

    var itemsNav = this.navigator;
    this.slides.each(function(i) {
      var button = $('<span>');
      button.click(function() {
        that.swipe.slide(i);
      });
      itemsNav.append(button);
    });

    this.navigator.appendTo(container);
  };

  this.startOnAppear = function() {
    var watcher = scrollMonitor.create( this.container, 200 );
    // watcher.lock();

    // start first slide when slider enters viewport
    watcher.enterViewport(function() {
      if (that.swipe) {
        that.swipe.slide(opts.startSlide, 1);
        that.swipe.restart();
      }
    });
  };

  this.makeSwipe = function(swipeOpts) {
    // Slides List
    this.slides = $(container).children();

    this.createContainer();

    // Swipe Instance
    $(container).Swipe(swipeOpts);
    swipe = $(container).data('Swipe');

    if (opts.navigation) {
      this.createNavigator();
      // init navigator active slide
      this.navigator.children().first()
        .addClass('active');
    }

    // slide active class
    this.slides.eq(swipeOpts.startSlide)
      .addClass('active');
  };


  // Swipe Callbacks
  var SwipeOpts = $.extend({}, opts, {
    callback: function(index, elem) {
      // started the change
      that.container.addClass('swiping');

      // Element change active
      // $(elem).siblings().removeClass('active');
      // $(elem).addClass('active');

      if (opts.callback) {
        opts.callback.call(that, index, elem);
      }
    },
    transitionEnd: function(index, elem) {
      // finished the change
      that.container.removeClass('swiping');

      // Element change active
      $(elem).siblings().removeClass('active');
      $(elem).addClass('active');

      if (opts.navigation) {
        // Navigator change active
        that.navigator.children()
          .removeClass('active')
          .eq(index)
          .addClass('active');
      }

      if (opts.transitionEnd) {
        opts.transitionEnd.call(that, index, elem);
      }
    }
  });

  this.makeSwipe(SwipeOpts);
  this.swipe = swipe;

  // move to first slide on appearance
  // Show slide 1 on appear screen
  if (opts.startOnAppear) {
    this.startOnAppear();
  }
}

module.exports = Gallery;


//////////////////
// WEBPACK FOOTER
// ./joor_modules/helpers/swipe/gallery.js
// module id = 10
// module chunks = 5